import { useEffect, useRef, useState } from "react";
import RightModal from "../../../components/Modal/RightModal";
import SavedFilterComponent from "../../../components/SavedFilters/SavedFilterComponent";
import { initialLogsFilterData } from "../../../utils/initialData";
import { countNonMatchingEntries, handleDropdownClose } from "../../../utils/utils";
import LogsFilterData from "./LogsFilterData";


const LogsFilter = ({ filterData, onSetFilterData, onCallApiAgain, }) => {

    const dropdownRef = useRef(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [selectedSavefilterId, setSelectedSaveFilterId] = useState(() => {
        const id = localStorage.getItem("selectedSavefilterId");
        return id ? id : "";
    });

    const count = countNonMatchingEntries(filterData, initialLogsFilterData);

    useEffect(() => {
        const handleClose = () => {
            setIsSidebarOpen(false);
        };
        handleDropdownClose(dropdownRef, handleClose);
    }, []);

    const handleFilter = () => {
        localStorage.setItem("filterData", JSON.stringify(filterData));
        onCallApiAgain();
        setIsSidebarOpen(false);
        setSelectedSaveFilterId("");
    };

    const handleSelectFilter = (value) => {
        const dataToSet = {
            interaction_type_user: value?.interaction_type_user,
            activity_count: value?.activity_count,
            activity_start_count: value?.activity_start_count,
            activity_end_count: value?.activity_end_count,
            module: value?.module,
            contact: value?.contact,
            interaction_type: value?.interaction_type,
            description: value?.description,

        };
        localStorage.setItem("filterData", JSON.stringify(dataToSet));
        onSetFilterData(dataToSet);
        onCallApiAgain(dataToSet);
    };

    const saveSearchFilterData = {
        interaction_type_user: filterData?.interaction_type_user,
        activity_count: filterData?.activity_count,
        activity_start_count: filterData?.activity_start_count,
        activity_end_count: filterData?.activity_end_count,
        module: filterData?.module,
        contact: filterData?.contact,
        interaction_type: filterData?.interaction_type,
        description: filterData?.description,

    };

    return (
        <div>
            <SavedFilterComponent
                from="Activity Pulse"
                count={count}
                isSidebarOpen={isSidebarOpen}
                saveSearchFilterData={saveSearchFilterData}
                selectedSavefilterId={selectedSavefilterId}
                initialFilterData={initialLogsFilterData}
                onCallApiAgain={onCallApiAgain}
                onSetFilterData={onSetFilterData}
                onSetSelectedSaveFilterId={(value) => {
                    setSelectedSaveFilterId(value);
                }}
                handleSelectFilter={handleSelectFilter}
                onSetIsSidebarOpen={(value) => setIsSidebarOpen(value)}
            />

            <RightModal
                isOpen={isSidebarOpen}
                onClose={() => {
                    setIsSidebarOpen(false);
                }}
                ref={dropdownRef}
                title={"Filter"}
                from="Activity Pulse"
                desc={`Enter Contract To Close information.`}
                onFilter={handleFilter}
                saveSearchFilterData={saveSearchFilterData}
                onSetSelectedSaveFilterId={(value) => setSelectedSaveFilterId(value)}
            >
                <LogsFilterData
                    isSidebarOpen={isSidebarOpen}
                    filterData={filterData}
                    onSetFilterData={onSetFilterData}
                />
            </RightModal>
        </div>
    )
}

export default LogsFilter;